import { styled as i, Box as n, useMediaQuery as s } from "@mui/material";
import u from "./DownloadButtons.js";
import k from "./DownloadLogo.js";
import { GAEventCategory as w } from "../constants/googleAnalytics.js";
import N from "../hooks/json/useFetchCurrentSeasonJson.js";
import l from "../../temp-lib/styles/theme.js";
import { jsxs as e, jsx as r, Fragment as d } from "react/jsx-runtime";
import "../../temp-lib/legacy/header/Header.js";
import "../../temp-lib/legacy/infoAccordion/InfoAccordion.js";
import "../../temp-lib/legacy/layout/Layout.js";
import "../../temp-lib/legacy/nav/Nav.js";
import "@metamask/detect-provider";
import "../../temp-lib/legacy/util/provider/Web3Instance.js";
import "jsonwebtoken";
import * as c from "ramda";
import "web3";
import "../../temp-lib/legacy/util/provider/WalletConnect.js";
import x from "../../temp-lib/config/index.js";
import "../deserializes/yup/download.js";
import "../../temp-lib/components/account/adeptus/AdeptusCodeInput.js";
import "../../temp-lib/components/account/adeptus/AdeptusSuccessPopup.js";
import "../../temp-lib/components/account/share/ConfirmButton.js";
import "../../temp-lib/components/account/share/FormControlledPassword.js";
import "i18next";
import "react";
import "../../temp-lib/components/account/share/EmailOTPSender.js";
import "../../temp-lib/components/share/mui/Textfield.js";
import "react-hook-form";
import "../../temp-lib/components/account/share/ForgotPasswordButton.js";
import "../../temp-lib/components/account/share/PopupTitle.js";
import "../../temp-lib/components/account/share/SendEmailOTPButton.js";
import "../../temp-lib/components/footer/Footer.js";
import "../../temp-lib/components/role/EnoughRoleOnly.js";
import "../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import "../../temp-lib/components/share/apeiron/ApeironButtonDisableTip.js";
import "../../temp-lib/components/share/apeiron/ApeironChickenPopup.js";
import "../../temp-lib/components/share/apeiron/ApeironCloseButton.js";
import "../../temp-lib/components/share/apeiron/ApeironCookieConsent.js";
import "../../temp-lib/components/share/apeiron/ApeironEllipsisTypography.js";
import "../../temp-lib/components/share/apeiron/ApeironGoToButton.js";
import "../../temp-lib/components/share/apeiron/ApeironImageButton.js";
import "../../temp-lib/components/share/apeiron/ApeironInfinityDataGrid.js";
import "../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import _ from "../../temp-lib/components/share/apeiron/ApeironLoopVideo.js";
import "../../temp-lib/components/share/apeiron/ApeironPagingDataGrid.js";
import "../../temp-lib/components/share/apeiron/ApeironReactPlayer.js";
import "../../temp-lib/components/share/apeiron/ApeironSectionTitle.js";
import "../../temp-lib/components/share/apeiron/ApeironTitle.js";
import "../../temp-lib/components/share/apeiron/ApeironTutorialDialog/ApeironTutorialDialog.js";
import { DEFAULT_ANIMATE_DURATION as L } from "../../temp-lib/constants/layout.js";
import "../../temp-lib/components/share/generic/CloseButton.js";
import "../../temp-lib/components/share/generic/IconText.js";
import "../../temp-lib/components/share/generic/ModalBox.js";
import "../../temp-lib/components/share/generic/Pagination.js";
import "../../temp-lib/components/share/generic/SearchEmptyState.js";
import "../../temp-lib/components/share/generic/Skeleton.js";
import "../../temp-lib/components/share/generic/TextInput.js";
import "next/script";
import "../../temp-lib/components/share/mui/Snackbar.js";
import T from "../../temp-lib/components/share/next/Image.js";
import $ from "../../temp-lib/components/share/next/NextLink.js";
import "../../temp-lib/components/share/popup/InfoPopup.js";
import "../../temp-lib/constants/account.js";
import "../../temp-lib/constants/googleAnalytics.js";
import "../../temp-lib/constants/query.js";
import "../../temp-lib/contexts/account/AccountContext.js";
import "../../temp-lib/contexts/account/Geetest4Context.js";
import "../../temp-lib/contexts/adeptus/AdeptusContext.js";
import "@apollo/client";
import "@apollo/client/link/error";
import "@apollo/client/utilities";
import "../../temp-lib/contexts/config/ConfigContext.js";
import "../../temp-lib/contexts/language/LanguageContext.js";
import "../../temp-lib/util/i18n/helper/locale.js";
import "path";
import "query-string";
import "p-retry";
import "ramda-adjunct";
import "../../temp-lib/contexts/share/LogicControlContext.js";
import { useTranslation as y } from "react-i18next";
import "../../temp-lib/contexts/fingerprint/FingerprintContext.js";
import "../../temp-lib/contexts/role/RoleContext.js";
import "../../temp-lib/contexts/share/DataGridContext.js";
import "../../temp-lib/contexts/share/MessageContext.js";
import "../../temp-lib/contexts/share/PersistQueryContext.js";
import "../../temp-lib/contexts/share/PreloadContext.js";
import "@tanstack/react-query";
import "../../temp-lib/contexts/share/ScreenLogContext.js";
import "../../config-lib/contexts/FrontendConfigContext.js";
import "../../config-lib/deserializes/yup/config.js";
import "../../config-lib/graphql/getFrontendConfig.js";
import "../../apostle-lib/deserializes/yup/apostle.js";
import "../../currency-lib/contexts/CurrencyContext.js";
import "../../temp-lib/contexts/web3/Web3Context.js";
import "../../wallet-lib/contexts/RoninNameServiceContext.js";
import "../../temp-lib/deserialize/yup/account.js";
import "../../temp-lib/deserialize/yup/chain.js";
import "../../temp-lib/deserialize/yup/locale.js";
import "../../temp-lib/deserialize/yup/page.js";
import "../../temp-lib/deserialize/yup/platform.js";
import "../../temp-lib/graphql/fragment/account.js";
import "date-fns";
import "date-fns/constants";
import "react-countdown";
import "next/router";
import "@walletconnect/utils";
import "@wagmi/core";
import "../../temp-lib/util/query/index.js";
import "../../temp-lib/deserialize/yup/adeptusCampaign.js";
import "../../temp-lib/graphql/query/getAdeptusCampaigns.js";
import "../../temp-lib/graphql/query/getPublicAccountDetail.js";
import "../../temp-lib/graphql/mutation/processEmailRegister.js";
import "../../currency-lib/constants/currency.js";
import "../../currency-lib/deserialize/yup/currency.js";
import "../../currency-lib/graphql/query/getCurrencyInfo.js";
import "../../currency-lib/graphql/query/getOffChainTokenBalances.js";
import "../../currency-lib/hooks/graphql/useGetTokenPriceToUSD.js";
import "../../temp-lib/util/erc20/index.js";
import "viem";
import "i18next-http-backend";
import "react-i18next/initReactI18next";
import "../../temp-lib/util/misc/formatNumberString.js";
import "../../temp-lib/util/yup/index.js";
import "../../temp-lib/wagmi/roninConnector.js";
import A from "../../ui-lib/components/ApeironBattleDemoTitle.js";
const D = i(n)`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;

  ${(o) => o.theme.breakpoints.up("res480")} {
    height: 1080px;
  }
  ${(o) => o.theme.breakpoints.down("res480")} {
    height: 900px;
  }
`, E = i(T)`
  aspect-ratio: 1080 / 740;
  min-height: 100%;
  filter: brightness(0.95) contrast(1.05) saturate(1.05);
  position: absolute;
`, B = i(_)`
  filter: contrast(1.05) saturate(1.1);
  height: 1080px;
  object-fit: cover;
  position: absolute;
  width: 100%;
`, v = i(k)`
  margin-top: 130px;
`, C = i(A)`
  align-self: flex-start;
  position: relative;
  ${(o) => o.theme.breakpoints.up("res1024")} {
    margin: 45px 0px 0px 90px;
  }
  ${(o) => o.theme.breakpoints.down("res1024")} {
    margin: 40px 0px 0px 20px;
  }
`, R = i(n)`
  height: 64px;
  ${(o) => o.theme.breakpoints.up("res1024")} {
    margin: 45px 0px 0px 90px;
  }
  ${(o) => o.theme.breakpoints.down("res1024")} {
    margin: 40px 0px 0px 20px;
  }
`, S = i(n)`
  display: flex;
  flex-direction: column;

  ${(o) => o.theme.breakpoints.up("res1024")} {
    align-items: flex-end;
  }
  ${(o) => o.theme.breakpoints.down("res1024")} {
    align-items: center;
  }
`, g = i($)`
  font-weight: 400;
  margin-right: 20px;
  margin-top: 15px;
  position: relative;
  text-decoration: underline;
  text-shadow: 2px 2px 10px #00000066;
  transition: color ${L}ms;

  :hover {
    color: #f1b535;
  }
`, Yt = (o) => {
  const {
    infoList: h,
    showTitle: b
  } = o, a = s(l.breakpoints.down("res768")), f = s(l.breakpoints.down("res480")), {
    t: m
  } = y(), {
    data: t
  } = N(), p = a ? t == null ? void 0 : t.breakpoint.mobile : t == null ? void 0 : t.breakpoint.desktop;
  return c.isNotNil(t) && c.isNotNil(p) ? /* @__PURE__ */ e(D, {
    children: [a ? /* @__PURE__ */ r(E, {
      src: p.background
    }) : /* @__PURE__ */ r(B, {
      src: p.background,
      playbackRate: 1.5
    }), b ? /* @__PURE__ */ r(C, {
      apeironTitle: m("battle_demo.download.page_title"),
      title: m("battle_demo.download.page_title")
    }) : /* @__PURE__ */ r(R, {}), /* @__PURE__ */ r(v, {
      barColor: p.barColor,
      barSide: p.barSide,
      logo: p.logo,
      name: t.name,
      title: t.title
    }), /* @__PURE__ */ e(S, {
      children: [/* @__PURE__ */ r(u, {
        analytic: {
          emitById: !0,
          event: w.Download
        },
        infoBackground: p.barVersion,
        infoList: h
      }), !f && /* @__PURE__ */ e(d, {
        children: [/* @__PURE__ */ r(g, {
          href: x.EXTERNAL_URL.NEWS,
          target: "_blank",
          children: `${m("download.release_note")} >>`
        }), /* @__PURE__ */ r(g, {
          href: x.EXTERNAL_URL.FAQ,
          target: "_blank",
          children: `${m("download.faq")} >>`
        })]
      })]
    })]
  }) : /* @__PURE__ */ r(d, {});
};
export {
  Yt as default
};
//# sourceMappingURL=DownloadSection.js.map
